import classNames from 'classnames'
import { type ReactNode } from 'react'
import { Box, Icon, type ITooltipProps, Status, Tooltip, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export type IAgentCardProps = {
  isBeta?: boolean
  title: string
  description?: string
  questionInfoTooltipProps?: ITooltipProps
  size?: 'medium' | 'small'
  rightContent?: ReactNode
  content?: ReactNode
}

export const AgentCard = ({
  isBeta,
  title,
  questionInfoTooltipProps,
  description,
  size = 'medium',
  rightContent,
  content,
}: IAgentCardProps) => {
  return (
    <div className={classNames(styles.container, styles[`size${size}`])}>
      <div className={styles.content}>
        <div className={styles.left}>
          <div className={styles.row}>
            <Typography
              ariaLabel={title}
              variant={size === 'small' ? 'text-input-field-r' : 'body-lg-medium'}
            >
              {title}
            </Typography>
            {questionInfoTooltipProps && (
              <Tooltip
                placement={'top'}
                label={questionInfoTooltipProps.label}
                breakWord
                {...questionInfoTooltipProps}
              >
                <Box
                  height={16}
                  width={16}
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'center'}
                >
                  <Icon icon={'question'} color={'var(--content-neutral-primary)'} fontSize={13} />
                </Box>
              </Tooltip>
            )}

            {isBeta && (
              <Status title={'Beta'} intent={'warning'} emphasis={'high'} size={'label'} />
            )}
          </div>
          {description && (
            <Typography ariaLabel={'description'} variant={'body-md-regular'} color={'tertiary'}>
              {description}
            </Typography>
          )}
        </div>

        {rightContent && <div className={styles.rightContent}>{rightContent}</div>}
      </div>
      {content}
    </div>
  )
}
